/** Eyebrow + title + subtitle header, shared by the role dashboards and the
 *  list/calendar pages. `size='lg'` is the oversight-home greeting variant
 *  (bigger title, width-capped subtitle); `md` (default) is the page variant. */
export function PageHeader({
  eyebrow,
  title,
  subtitle,
  size = 'md',
}: {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  size?: 'md' | 'lg';
}) {
  return (
    <header className="space-y-0.5">
      {eyebrow ? <div className="eyebrow">{eyebrow}</div> : null}
      <h1
        className={
          size === 'lg'
            ? 'text-3xl sm:text-4xl font-semibold'
            : 'text-2xl sm:text-3xl font-semibold'
        }
      >
        {title}
      </h1>
      {subtitle ? (
        <p
          className={
            size === 'lg'
              ? 'text-sm text-muted-foreground max-w-[640px]'
              : 'text-sm text-muted-foreground'
          }
        >
          {subtitle}
        </p>
      ) : null}
    </header>
  );
}
